import { ff } from '@atlassian/jira-feature-flagging-using-meta';

import { getIsNewValueRequested } from '../../common/utils/get-feature-flag-value';
import {
	GIRA_AGG_MIGRATION_ISARCHIVED_FLAG,
	isParentInIssueViewEnabled,
} from '../../feature-flags';

export const getMainIssueViewAggQueryFeatureFlagVariables = () => ({
	issueViewRelayCascadingSelectFlag: ff(
		'issue.details.relay-cascading-select-field-issue-view-layout-integration',
	),
	giraAGGMigrationIsArchivedFlag: getIsNewValueRequested(GIRA_AGG_MIGRATION_ISARCHIVED_FLAG),
	parentInIssueViewFlag: isParentInIssueViewEnabled(),
	isCompassComponentsEnabled: ff('compass-components-in-jira-components_xw42u', false),
	giraAGGMigrationAttachmentsFlag: ff('issue.details.gira-agg-migration-attachments_ecebe'),
	jsmProductsEntitlementsM2Flag: ff('products-and-entitlements-m2'),
	isRelayReleaseVersionFieldIssueViewIntegrationEnabled: ff(
		'issue.details.relay-release-version-field-issue-view-integration',
	),
	issueViewRelayGoalsFlag: ff('hrz-716-integrate-goal-picker-into-issue-view', false),
});
